import {HistoricalOptionCache} from "./HistoricalOptionCache";
import {HistoricalPriceService} from "../price/historical/HistoricalPriceService";
import {HistoricalPriceResponse} from "../price/historical/HistoricalPriceModels";

export class HistoricalOptionService {

    public static id = "historicalOptionService";

    private cache = new HistoricalOptionCache();

    /** @ngInject */
    public constructor(private historicalPriceService: HistoricalPriceService) {

    }

    public async get(underlying: string, asAt: string): Promise<HistoricalPriceResponse> {
        return this.cache.getOrCompute(underlying, asAt, this.retrieveData.bind(this));
    }

    private retrieveData(underlying: string, asAt: string): Promise<HistoricalPriceResponse> {
        return this.historicalPriceService.prices(underlying, asAt);
    }
}
